import { useNavigate } from "react-router-dom";
import { SvgIcon, Button } from "@mui/material";
import { useIsInQuickLink } from "../../../utils/hooks";
import { newDocumentPath, useCreatableDocumentTypes } from "./documentTypes";

const styleBtn = {
  backgroundColor: "secondaryGreen.main",
  mr: 0.5,
  ml: 0.5,
  "&:hover": {
    backgroundColor: "#4AB0A6",
  },
};

export default ({ patientId }) => {
  const navigate = useNavigate();
  const isInQuickLink = useIsInQuickLink();
  const creatableDocumentTypes = useCreatableDocumentTypes();

  if (isInQuickLink) return;

  if (creatableDocumentTypes.length === 0) return;

  return (
    <>
      {creatableDocumentTypes.map((documentType) => (
        <Button
          key={documentType.basePath}
          size="small"
          variant="contained"
          sx={styleBtn}
          onClick={() => navigate(`${newDocumentPath(documentType)}/?patientId=${patientId || ""}`)}
        >
          <SvgIcon sx={{ fontSize: 20 }}>
            <documentType.Icon />
          </SvgIcon>
          Nueva {documentType.title}
        </Button>
      ))}
    </>
  )
};
